import { create, show, useModal } from "@ebay/nice-modal-react";

import FlashContext from "components/FlashMessages/FlashContext";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import { FederationProvider } from "types/generated";

import { IDENTITY_FEDERATION_UNLINK } from "../../gql";

const useConnectionUnlink = createDefaultMutationHook(IDENTITY_FEDERATION_UNLINK);

type DisconnectConfirmationProps = {
  name: string;
  provider: FederationProvider;
};

const DisconnectConfirmation = create(function DisconnectConfirmation({
  name,
  provider,
}: DisconnectConfirmationProps) {
  const modal = useModal();
  const { reportSuccess } = useTypedContext(FlashContext);

  const [unlink, { loading }] = useConnectionUnlink();

  const handleDisconnect = () => {
    unlink({ provider }, (data) => {
      if (data?.identityFederationUnlink) {
        reportSuccess({ message: `${name} disconnected.` });
        modal.hide();
      }
    });
  };

  return (
    <DeleteConfirmationModal
      title={`Disconnect ${name}`}
      onConfirm={handleDisconnect}
      isLoading={loading}
      isDismissable={!loading}
      confirmationButtonLabel="Disconnect"
    >
      <ConfirmationModalMessage>
        Are you sure you want to disconnect {name}? You will no longer be able to use it to
        attribute your activity across tools.
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showDisconnectConfirmation = (props: DisconnectConfirmationProps) =>
  show(DisconnectConfirmation, props);
